export default {
  // 简体
  0: {
    allStores: '全部店',
    businessHours: '营业时间：',
    address: '地址：',
  },

  // 繁体
  1: {
    allStores: '全部店',
    businessHours: '營業時間：',
    address: '地址：',
  },

  // 英文
  2: {
    allStores: 'All',
    businessHours: 'Business hours: ',
    address: 'Address: ',
  },
};
